<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre9"><span id="Page_18" title="[Pg 18]"></span></p>
<div class="figcenter4" id="p018">
<img alt="Decoration" class="w" id="id-1430085647819699634" src="Images/img0003.jpg"/>
</div>
</div>
<div class="pg-boilerplate" id="calibre_pb_1"></div>
<h2 class="nobreak" id="CHAPTER_II">CHAPTER II.<br class="calibre6"/>
<span class="fs">ALL-HALLOWE’EN.</span></h2>
<p class="calibre9">“Where are those children?” Mrs. Holmes was
saying when, in answer to a ring at the door, Prue
announced two ladies to see “Mr. and Mrs. Holmes
and the young ladies.”</p>
<p class="calibre9">On going to the drawing-room the host and hostess
were greeted by a tall, spare person in deep mourning,
who remarked, in sepulchral tones, “We have come to
see you on a matter of great importance.” There was
a little sound from the second visitor. Was it a laugh
or a cough? This shorter individual wore a long
cloak, while a black veil was tied closely over the
face.</p>
<p class="calibre9">While Mr. Holmes was bowing politely and Mrs.
Holmes was waiting expectantly for further remark,
suddenly every light went out, and when the gas was
relighted not a sign of the guests could be seen, but a
chorus of unearthly groans and shrieks proceeded from
no one knew where, to the terror of Mellicent, who
cried, “Oh, mamma, what is it?”</p>
<p class="calibre9">Again the gas went out, and the groans and wails<span id="Page_19" title="[Pg 19]"></span>
seemed directly in their ears. Then in the darkness
three white figures glimmered ghostly, but a second
relighting showed no one there.</p>
<p class="calibre9">“This is really uncanny!” ejaculated Lisa.</p>
<p class="calibre9">“My dear,” said grandma, who was smoothing
Mellicent’s golden head and calming the little girl’s
fears, “don’t you know it is only those witchy children?”</p>
<p class="calibre9">“I’ll warrant Persis is at the bottom of it,” cried
Lisa. “She was so down on the boys coming, and
here she is the very first one to get them into mischief.”</p>
<p class="calibre9">“I don’t know what you mean,” said a voice,
plaintively. “You’re always blaming me for everything.”
And Lisa turned, astonished to see Persis
curled up in an arm-chair by the bay-window, as if
she had been taking a nap there.</p>
<p class="calibre9">“Why, where did you come from?” And Lisa gave
utterance to her question in tones of astonishment.
“I know you haven’t been there all this time.”</p>
<p class="calibre9">“How do you know? Can you take your oath on
it?”</p>
<p class="calibre9">“I don’t take oaths; but I haven’t the least recollection
of seeing you since dinner, when you were
playing with the boys in the hall.”</p>
<p class="calibre9">“Well, your memory is not to be relied upon,” observed
Persis, jauntily. “If I should tell you how
long I have been here you wouldn’t believe it.”</p>
<p class="calibre9">“I am going to light the lamp,” Lisa remarked.
“I don’t want any more Stygian darkness. Why,
where is it? I thought it was on the table. Prue<span id="Page_20" title="[Pg 20]"></span>
must have forgotten to bring it back when she took it
out to fill it.” But, as she was in the act of leaving
the room, again all was dark.</p>
<p class="calibre9">“I’ll catch those tricksters,” said Mr. Holmes.
“This is getting too much of a joke,” and he secreted
himself behind the door as the three white-sheeted
forms appeared. The first two were too quick for
him, but the last one was grabbed, and as Lisa brought
in the lighted lamp Basil was discovered.</p>
<p class="calibre9">The poor boy was covered with confusion at being
found the culprit, and Persis came to the rescue by
saying, “Papa, it was not his fault; we coaxed him
into it, Porter and I, and it was I who blew down the
gas-pipes to put the lights out. It is All-Hallowe’en,
you know.”</p>
<p class="calibre9">A grim smile passed over Mr. Holmes’s face.
“Then I suppose you expect me to let you off,” he
replied.</p>
<p class="calibre9">“Oh, yes, papa, please. It is the boys’ first evening
here, and I don’t want them to think just yet that you
are an ogre.”</p>
<p class="calibre9">This was too much for Mr. Holmes, and he laughed.
“How much did that remark imply, I wonder, you
sauce-box?” he said.</p>
<p class="calibre9">“Why? Oh, why, papa?” And Persis covered her
face with both hands. “I believe I did insinuate that
you were really ogrish at all times, and you aren’t a
bit ever. He isn’t, boys; he is usually a dear; but
once in a while, when we are very bad, he can be terrible.
I warn you that when papa is seriously offended
he is not savage exactly, but so ’way, ’way up—so<span id="Page_21" title="[Pg 21]"></span>
stately and solemn—that he can scare you out of your
wits.”</p>
<p class="calibre9">“Thank you for the reputation,” returned Mr.
Holmes. “I am glad you are ready to back me up
in maintaining proper discipline. Now, no more tricks
to-night.”</p>
<p class="calibre9">“Not even apple-bobbing or meal balls?” said Mellicent,
dolefully.</p>
<p class="calibre9">“Meal balls are silly,” sniffed Persis. “Who wants
to waste time on stupid names rolled up in a ball of
chicken food? I’d rather run around the block with
my mouth full of water.”</p>
<p class="calibre9">“What’s that for?” queried Porter.</p>
<p class="calibre9">“Oh, you hear your future husband’s name called,
they say. I like the fun of it. It is so hard to run
and keep the water in your mouth at the same time.
Then salt-cake is fun, too, only I always laugh and
nearly always say something when I oughtn’t to
speak.”</p>
<p class="calibre9">“I think apple-bobbing will do for to-night,” said
Mrs. Holmes. “You can go in the kitchen if you
like.”</p>
<p class="calibre9">“Oh! And mayn’t we make some taffy, too,
mamma?” pleaded Mellicent. “Grandma will help
us; won’t you grandma?”</p>
<p class="calibre9">“To be sure,” was the ready response.</p>
<p class="calibre9">And so it was settled, while the tricksters congratulated
themselves that they were let off so easily and
that such a pleasant prospect was theirs.</p>
<p class="calibre9">Grandmamma Estabrook was a famous maker of
taffy. “She always knows just when it is done,”<span id="Page_22" title="[Pg 22]"></span>
Persis informed Porter. “And it never gets burnt,
and never is the least bit too soft. I am always in
such a hurry that I am very apt to take it up before
it is done, and it gets, oh, so sticky. This will be fine,
I know. We will bob for apples while it is boiling.”</p>
<p class="calibre9">So, although Prue at first looked askance at seeing
her kitchen invaded, she was soon ready to lend her
services to the furnishing of amusement for “Holly
Eve,” and brought in a big tub, which the children
filled half-full of water, and the merry game began.
After much sputtering and splashing, Porter managed
to grasp an apple with his teeth, and Mellicent followed
suit.</p>
<p class="calibre9">“They are the slipperiest things I ever saw,” declared
Basil, lifting a dripping face from the tub.
“Just as I think I have one sure over it rolls and I
am cheated. I think I’ll be more of a success at taffy-pulling.
My, that looks good!” for Mrs. Estabrook
was pouring the seething mass into pans, and the
children carried them to the summer-kitchen to cool.</p>
<p class="calibre9">While the others were laughing and talking over
their sticks of taffy, Basil was turning over in his
mind the advisability of trying to win Mrs. Estabrook’s
approval of bicycle riding for girls. This
amusement was at that time in the early stage of its
popularity, and was looked upon with discredit by
many persons. Basil’s attentive, thoughtful ways evidently
produced a good impression upon grandma, and
she talked cheerily to him of his coming work, of his
life at home, and such topics as she thought might
interest him.</p>
<p class="calibre9"><span id="Page_23" title="[Pg 23]"></span></p>
<p class="calibre9">“I hope you are not going to be homesick,” she
said.</p>
<p class="calibre9">“I don’t believe we shall be,” answered Basil, cordially.
“You’re all so awfully jolly,—I mean so nice
and homelike,—and you know Port and I never had
sisters, so we’ll learn a lot about girls, I expect.”</p>
<p class="calibre9">Grandma smiled at the naïve speech. “Have you
no girl cousins?” she asked.</p>
<p class="calibre9">“Yes, we have one who lives near us. She’s awfully
nice, too; and when we go out on our bikes very often
she goes along.”</p>
<p class="calibre9">“Oh, she rides a bicycle!” And Basil saw disapproval
of this “nice” cousin written on Mrs. Estabrook’s
face.</p>
<p class="calibre9">“She’s such a real good girl. She’s the rector’s
daughter, you know,” he hastened to say.</p>
<p class="calibre9">“What! Dr. Allison’s daughter? He is your
rector, I have heard your mother say.”</p>
<p class="calibre9">“So he is, and he’s one of the finest fellows you
ever saw.”</p>
<p class="calibre9">“Yes, that is what I have always been told,” assented
Mrs. Estabrook, “and therefore I can hardly
reconcile my idea of his good judgment to the fact of
his daughter’s riding a bicycle.”</p>
<p class="calibre9">“Why, don’t you think it’s good for girls? I wish
you could see the difference it has made in Mabel Allison.
She used to be so delicate. She had dyspepsia
and all sorts of things, and now she looks like another
girl. Say, Mrs. Estabrook, don’t you think it would
be nice for Persis?”</p>
<p class="calibre9">“I don’t think Persis needs it.”</p>
<p class="calibre9"><span id="Page_24" title="[Pg 24]"></span></p>
<p class="calibre9">“But it would be fun for her. You would not
mind our teaching her, would you? It wouldn’t do
any harm for her to know how.”</p>
<p class="calibre9">“No, I suppose not. I know she is very anxious
to learn; but I should dislike very much to see her in
public mounted on a wheel.”</p>
<p class="calibre9">“Oh, well, we won’t let any one see her. We’ll go
into the side street, and you can watch us from your
window.”</p>
<p class="calibre9">Mrs. Estabrook did not reply, and Basil, taking
silence for consent, went over to Persis and told her
with great satisfaction that she was to learn to ride as
soon as the boys’ wheels should come.</p>
<p class="calibre9">The part of the city where the Holmes family lived
was quite suburban, although only fifteen minutes’
ride by trolley to the heart of the city and within a
short distance of the university where Mr. Holmes
held a professorship. Theirs was a corner house, and
the quiet street which ran along the side of the garden
was at times in the day almost deserted, and it was
here that the boys intended to initiate Persis into the
mysteries of bicycle riding.</p>
<p class="calibre9">A more excited girl than Persis was over the prospect
could scarcely be found. “When once grandma
sees how I can ride she’ll not say a word against it,”
she confided to Lisa. “Then you’ll learn, and we’ll
all go out together. Won’t it be fine? I’m so glad
Basil and Porter have come.”</p>
<p class="calibre9">“You sang another song this morning,” returned
Lisa.</p>
<p class="calibre9">This was after the taffy had been pulled till it was<span id="Page_25" title="[Pg 25]"></span>
a delicate straw-color, and the young people, having
eaten all they could manage, had said their good-nights
with much complacency, feeling that the evening
had furnished them with all the amusement they
could have expected.</p>
<p class="calibre9">“Grandma, you’re a dear, sweet darling. I love
you to pieces,” Persis said. “I’m so happy to think
you don’t mind my learning to ride.”</p>
<p class="calibre9">“Who said I didn’t mind?”</p>
<p class="calibre9">“Why, Basil. Didn’t you mean it?” And for a
moment Persis’s hopes fell. Grandma was too tender-hearted
to declare she had never said anything of the
kind, and so she only kissed the eager face and said,
“Well, my child, I am old-fashioned, I suppose, but
you will not go off the side street, will you? I can’t
quite stand the thought of seeing you in a more public
place.” And Persis’s hopes rose again.</p>
<p class="calibre9">“I think it has been a perfectly lovely Hallowe’en,”
she avowed to Lisa, as she vigorously brushed
her hair.</p>
<p class="calibre9">“Yes, it has been great fun for you. After all your
talk about those boys coming, I notice you are the
first one to be hand and glove with them. That’s
just like you, always at one extreme or the other,”
Lisa retorted. She could not entirely forgive Persis
for having been the first to win the boys’ good graces.</p>
<p class="calibre9">“Well, I’d like to know if you didn’t have the
same chance for a good time that I did. You should
have made the most of your opportunities. That’s
just like you, Lisa. You’re always complaining that
I have good times, when you have exactly the same<span id="Page_26" title="[Pg 26]"></span>
chances that I have. The only difference is, that I
go and meet the chances, and you sit and wait for
them to come to you, because you’re so terribly afraid
that somehow you’ll be called upon to step down from
your pedestal. If you didn’t cling so close to that
pedestal of yours you’d have a better time. I don’t
sit still all the time looking for homage. I’d have a
pretty stupid time if I did.”</p>
<p class="calibre9">“And precious little you’d get if you looked for
it,” asserted Lisa, now more ruffled than before. “I
am the eldest, and of course certain things are due
me.”</p>
<p class="calibre9">“Oh, dear!” thought Persis. “I wish Lisa were
not so terribly tenacious of her prerogatives. They
are always getting in my way, and I get snubbed because
I don’t regard them. I wonder if I would be
so top-lofty and sniffy if I were the eldest. Maybe I
would be.” And she suppressed a smile as Lisa threw
her a haughty glance from under half-closed lids,—a
glance which was meant to convey a sense of superiority.</p>
<p class="calibre9">“Lisa, you would surely have been a Pharisee if you
had lived in Bible times,” remarked the irrepressible
Persis.</p>
<p class="calibre9">“Then I suppose you would have been a publican
and sinner. You don’t have to go back to those times
to be the latter.”</p>
<p class="calibre9">Persis laughed, but she was inwardly annoyed, and,
jumping up, she opened the door which led into Mellicent’s
little room, leaving her elder sister alone.</p>
<p class="calibre9">“Mell, I’m going to sleep with you,” she announced.<span id="Page_27" title="[Pg 27]"></span>
“Lisa is on her high horse to-night, and there’s not
room for her to canter around while I am there.”</p>
<p class="calibre9">Mellicent sleepily moved over to give Persis room.
She was used to these little disturbances between her
two sisters; and, although it was always Persis who
left Lisa in possession, it was sometimes one and sometimes
the other who received Mellicent’s sympathies.
She was easily influenced, and any little appeal to her
vanity, or a properly phrased remark as to the state
of her health, generally won her favor. Therefore
when Persis said, “I hope that taffy didn’t give you a
headache,” she replied, “I had one this morning;
but I’m quite used to them, you know.” This with
a martyr-like air.</p>
<p class="calibre9">“So it’s a question of headache with or without
taffy, isn’t it?” returned Persis, comfortably. “I’ll
take mine with this time. Did you know, Mell, that
I am going to ride a wheel? And if ever I get one
of my own you shall share it with me for letting me
share your bed, and Miss Lisa can whistle for a
ride.”</p>
<p class="calibre9">“Audrey is going to get a wheel,” Mellicent informed
her sister.</p>
<p class="calibre9">“Is she? Then of course you’ll want to ride with
her. Well, I’ll teach you, and you shall use mine—when
I get it. Oh, don’t you hope we can have
one?”</p>
<p class="calibre9">“I didn’t care till Audrey made up her mind about
it,” returned Mellicent.</p>
<p class="calibre9">“What a loyal little subject you are! What makes
you like Audrey so much?”</p>
<p class="calibre9"><span id="Page_28" title="[Pg 28]"></span></p>
<p class="calibre9">“Why, Persis, she is so lovely, and you know she
thinks she is descended from the same family of Vanes
as that to which Sir Harry Vane belonged. Don’t
you know, that dear Sir Harry whose statue we saw in
the Boston Public Library last summer? It is so
dreadful to think of his having been beheaded.”</p>
<p class="calibre9">“Yes, so it is, but I don’t see that it adds anything
special to Audrey’s attractions. I think I must hunt
up a headless ancestor. I wonder if we haven’t one
hanging somewhere on our family tree.”</p>
<p class="calibre9">“Oh, Persis! how could he hang on a tree without
a head?”</p>
<p class="calibre9">“Sure enough, he couldn’t, could he? He’d have
to perch there with his head under his arm like—who
was it?—oh, yes, St. Denis, who carried his head in his
hands after he was beheaded. I don’t believe I’d care,
myself, for an ancestor who had to hang. I’ll tell you,
Mell, who I think is a nice girl.”</p>
<p class="calibre9">“Who?”</p>
<p class="calibre9">“Annis Brown.”</p>
<p class="calibre9">“What! that quiet little thing? She hasn’t a bit
of style; she’s as plain as a pipe-stem.”</p>
<p class="calibre9">“I know it, but I like her.”</p>
<p class="calibre9">“Audrey says she is a parvenu.”</p>
<p class="calibre9">“Humph! Just because her mother keeps boarders.
That sounds like Audrey.”</p>
<p class="calibre9">“Now, Persis, I won’t have you run down Audrey.”</p>
<p class="calibre9">“I won’t, then. I’m not going to get into any more
squabbles to-night. Audrey is an awfully nice girl,
only she does brag a little too much.”</p>
<p class="calibre9">“She has something to brag about.”</p>
<p class="calibre9"><span id="Page_29" title="[Pg 29]"></span></p>
<p class="calibre9">“Well, I’m going to find out if some other people
haven’t just as much. Never mind, Mell, Audrey’s all
right, and so are you. Here we are talking ourselves
wide-awake, and it will be morning before we’re ready
for it. Let’s turn over and go to sleep,” which they
proceeded to do.</p>
<div class="chapter">
<p class="calibre9"><span id="Page_30" title="[Pg 30]"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?9d08b3ca